import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-contactpersonenview',
  templateUrl: './contactpersonenview.component.html',
  styleUrls: ['./contactpersonenview.component.less']
})
export class ContactpersonenviewComponent implements OnInit {


  @Input() persoon: any;
  @Output() deleted = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

}
